module.exports = __webpack_public_path__ + "static/media/icon-addsensor.7f68459a.svg";